import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Phone, MessageCircle, Send, X, MessagesSquare } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { useLang } from "../lib/i18n";

export default function FloatingContact() {
  const site = useSite();
  const { lang } = useLang();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const c = site?.settings?.contacts;

  if (!c || pathname.startsWith("/admin") || pathname.startsWith("/login")) return null;

  const actions = [
    c.phone && { icon: Phone, label: lang === "ru" ? "Позвонить" : "Call", href: `tel:${c.phone}` },
    c.max && { icon: MessageCircle, label: "MAX", href: "https://max.ru/u/f9LHodD0cOKIQ3CkI05ZDHFq3wnbhdSpV1OrgE68OxpVwSEtfmM8rQLNqBE" },
    c.telegram_dm && { icon: Send, label: "Telegram", href: c.telegram_dm },
    c.whatsapp && { icon: MessageCircle, label: "WhatsApp", href: c.whatsapp },
  ].filter(Boolean);

  return (
    <div className="fixed bottom-5 left-5 z-[80] flex flex-col items-start gap-3">
      <AnimatePresence>
        {open && actions.map((a, i) => (
          <motion.a
            key={a.label}
            href={a.href}
            target={a.href.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={`float-${a.label}`}
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            transition={{ duration: 0.25, delay: i * 0.04 }}
            className="flex items-center gap-3 pl-3 pr-4 py-2.5 text-[0.72rem] uppercase tracking-[0.14em] text-argali-ivory border"
            style={{ background: "rgba(17,17,15,0.85)", backdropFilter: "blur(8px)", borderColor: "rgba(215,184,117,0.35)" }}
          >
            <a.icon size={16} className="text-argali-gold" /> {a.label}
          </motion.a>
        ))}
      </AnimatePresence>
      <button
        data-testid="float-contact-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? (lang === "ru" ? "Закрыть контакты" : "Close contacts") : (lang === "ru" ? "Связаться" : "Contact")}
        className="w-12 h-12 flex items-center justify-center border text-argali-ivory shadow-lg"
        style={{ background: "rgba(17,17,15,0.9)", borderColor: "rgba(200,138,43,0.55)", backdropFilter: "blur(8px)" }}
      >
        {open ? <X size={19} /> : <MessagesSquare size={19} className="text-argali-gold" />}
      </button>
    </div>
  );
}
